import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface UiTab {
  label: string;
  value: any;
  count?: number | null;
}

@Component({
  selector: 'ui-tabs',
  templateUrl: './ui-tabs.component.html',
  styleUrl: './ui-tabs.component.scss',
})
export class UiTabsComponent {
  @Input() tabs: UiTab[] = [];
  @Input() activeValue: any = null;
  @Output() activeValueChange = new EventEmitter<any>();

  select(value: any): void {
    if (this.activeValue === value) return;
    this.activeValueChange.emit(value);
  }
}
